import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'
import { ORG_TOKEN_ALERT_SUMMARY_KEY } from '../members/useMembers'

const MANAGE_API_TOKEN_LIST_KEY = 'manage-api-token-list'

type ApiTokenCreateRequestPayload = {
  orgId: string
  appUserId?: string
}

type APITokenResponse = {
  id: string
  jwtToken: string
  jwtExpiration: number
  createdAt: string
}

type ApiTokenGetRequest = {
  appUserId?: string
  orgId?: string
}

type ApiTokenDeleteRequestPayload = {
  ids: string[]
}

type ApiTokenGetResponse = {
  data: APITokenResponse[]
}

export function useCreateToken() {
  return useMutation({
    mutationFn: async (payload: ApiTokenCreateRequestPayload) => {
      const { data } = await apiClient.post<APITokenResponse>(`/int/v3/api-token`, payload)
      return data
    },
  })
}

export function useDeleteTokens() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: ApiTokenDeleteRequestPayload) => {
      await apiClient.delete(`/int/v3/api-token/batch`, { data: payload })
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [ORG_TOKEN_ALERT_SUMMARY_KEY] }),
  })
}

export function useGetTokens(params: ApiTokenGetRequest) {
  return useQuery({
    queryKey: [MANAGE_API_TOKEN_LIST_KEY, params],
    queryFn: async () => {
      const { data } = await apiClient.get<ApiTokenGetResponse>('/int/v3/api-token', { params })
      return data
    },
    enabled: !!params.appUserId && !!params.orgId,
  })
}
